<template>
  <section class="next-week u-margin-big-top-bottom" id="sectionnextweek">
    <div class>
      <h1
        class="next-week-heading header-primary--sub u-text-center u-uppercase u-margin-big-bottom"
      >next week</h1>
    </div>

    <div class="next-week--container">
      <table class="next-week--container-table">
        <tr class="next-week--container-table--tr">
          <th>Date</th>
          <th>Day</th>
          <th>Fajr</th>
          <th>Sunrise</th>
          <th>Zuhr</th>
          <th>Asr</th>
          <th>Magrib</th>
          <th>Isha</th>
          <th>Hijri</th>
        </tr>
        <tr v-for="(time, index) of nextweek" :key="index" class="next-week--container-table--tr">
          <td>{{time['nextDate']}}</td>
          <td>{{time['nextDay']}}</td>
          <td>{{zeroPadding(time['fajr']['hour'])}}:{{zeroPadding(time['fajr']['minute'])}}</td>
          <td>{{zeroPadding(time['sunrise']['hour'])}}:{{zeroPadding(time['sunrise']['minute'])}}</td>
          <td>{{zeroPadding(time['zuhr']['hour'])}}:{{zeroPadding(time['zuhr']['minute'])}}</td>
          <td>{{zeroPadding(time['asr']['hour'])}}:{{zeroPadding(time['asr']['minute'])}}</td>
          <td>{{zeroPadding(time['magrib']['hour'])}}:{{zeroPadding(time['magrib']['minute'])}}</td>
          <td>{{zeroPadding(time['isha']['hour'])}}:{{zeroPadding(time['isha']['minute'])}}</td>
          <td>{{time['currentHijriDay']}}</td>
        </tr>
      </table>
    </div>
  </section>
</template>
<script>
export default {
  props: ['nextweek'],
  methods: {
    zeroPadding(value) {
      return value < 10 ? '0' + value : value;
    }
  }
}
</script>